var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInsta(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x37__stroke",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.149,
    cy: 1.003,
    r: 1.278,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffb140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.256,
    stopColor: "#ff5445"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.599,
    stopColor: "#fc2b82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8e40b7"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Instagram_1_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13",
    "data-name": "Rectangle 13",
    width: 18,
    height: 18,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Instagram",
    d: "M14.594,4.114a1.059,1.059,0,1,1-1.059-1.059A1.059,1.059,0,0,1,14.594,4.114ZM8.824,11.766a2.941,2.941,0,1,1,2.941-2.941A2.941,2.941,0,0,1,8.824,11.766Zm0-7.473a4.532,4.532,0,1,0,4.532,4.532A4.531,4.531,0,0,0,8.824,4.293Zm0-2.7c2.356,0,2.635.009,3.566.051a4.881,4.881,0,0,1,1.639.3,2.734,2.734,0,0,1,1.015.66A2.732,2.732,0,0,1,15.7,3.62a4.885,4.885,0,0,1,.3,1.639c.042.931.051,1.21.051,3.566s-.009,2.635-.051,3.566a4.881,4.881,0,0,1-.3,1.639A2.923,2.923,0,0,1,14.029,15.7a4.885,4.885,0,0,1-1.639.3c-.93.042-1.21.051-3.566.051s-2.635-.009-3.566-.051a4.881,4.881,0,0,1-1.639-.3,2.734,2.734,0,0,1-1.015-.66,2.734,2.734,0,0,1-.66-1.015,4.885,4.885,0,0,1-.3-1.639c-.042-.931-.051-1.21-.051-3.566s.009-2.635.051-3.566a4.881,4.881,0,0,1,.3-1.639,2.734,2.734,0,0,1,.66-1.015,2.732,2.732,0,0,1,1.015-.66,4.885,4.885,0,0,1,1.639-.3C6.189,1.6,6.468,1.59,8.824,1.59Zm0-1.59c-2.4,0-2.7.01-3.638.053a6.477,6.477,0,0,0-2.142.41A4.324,4.324,0,0,0,1.481,1.481,4.324,4.324,0,0,0,.463,3.044a6.478,6.478,0,0,0-.41,2.142C.01,6.127,0,6.428,0,8.824s.01,2.7.053,3.638A6.478,6.478,0,0,0,.463,14.6a4.324,4.324,0,0,0,1.018,1.563,4.326,4.326,0,0,0,1.563,1.018,6.478,6.478,0,0,0,2.142.41c.941.043,1.242.053,3.638.053s2.7-.01,3.638-.053a6.478,6.478,0,0,0,2.142-.41A4.512,4.512,0,0,0,17.186,14.6a6.478,6.478,0,0,0,.41-2.142c.043-.941.053-1.242.053-3.638s-.01-2.7-.053-3.638a6.478,6.478,0,0,0-.41-2.142,4.326,4.326,0,0,0-1.018-1.563A4.326,4.326,0,0,0,14.6.463a6.478,6.478,0,0,0-2.142-.41C11.522.01,11.221,0,8.824,0Z",
    fillRule: "evenodd",
    fill: "url(#radial-gradient)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsta);
export default __webpack_public_path__ + "static/media/insta.ba0473f3c34134d2bfecf873bf9e1540.svg";
export { ForwardRef as ReactComponent };